import React from "react";
import { ContextProvider } from "./reducer";

const ConnectReducers = ({ children }) => {
  return <ContextProvider>{children}</ContextProvider>;
};

export default ConnectReducers;
